module.exports = __webpack_public_path__ + "static/media/ic_whats_covered_myway.89d27e0a.svg";